interface PageHeaderProps {
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}

export default function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="pb-5 border-b border-gray-200 dark:border-gray-700 sm:flex sm:items-center sm:justify-between">
      <div>
        <h1 className="text-2xl font-semibold leading-6 text-gray-900 dark:text-white">{title}</h1>
        {description && (
          <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">{description}</p>
        )}
      </div>
      {actions && (
        <div className="mt-3 sm:ml-4 sm:mt-0">{actions}</div>
      )}
    </div>
  );
}